export default __webpack_public_path__ + "static/media/image-ph-health-briefing-m@3x.bf5ce3f2.webp";